import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    isFetchedOrder: false,
    imageLoading: false,
    fetched: false,
    savingInProgress: false,
    orderCheckLoading: false,
    search: "",
    tableOptions: {
      page: 1,
      last_page: 1,
      itemsPerPage: 15,
      sortBy: ["human_number"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
    ordersTotal: null,
    orders: [],
    comment: {
      text: null,
      sms: false,
      email: false,
    },
    newOrder: {
      customer_car_id: null,
      customer: {
        first_name: null,
        country: {
          name_ru: null,
          name_en: null,
        },
        city: {
          name_ru: null,
          name_en: null,
        },
      },
      shop_comment: "",
      items: [],
    },
    order: {
      customer: {
        first_name: null,
        country: {
          name_ru: null,
          name_en: null,
        },
        city: {
          name_ru: null,
          name_en: null,
        },
      },
      items: [],
      log: [],
      inspection_report: {
        vehicle_type: null,
        marks: [],
        mileage: null,
        equipments: [],
        fuel: 0,
        paintwork_defect: null,
        special_marks: null,
      },
    },
    orderPresented: {
      customer: {
        first_name: null,
        country: {
          name_ru: null,
          name_en: null,
        },
        city: {
          name_ru: null,
          name_en: null,
        },
      },
      items: [],
      log: [],
      inspection_report: {
        vehicle_type: null,
        marks: [],
        mileage: null,
        equipments: [],
        fuel: 0,
        paintwork_defect: null,
        special_marks: null,
      },
    },
    findOrderString: null,
    findedOrders: [],
    isFindingOrders: false,
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    removeFromState(state, data) {
      let items = [];
      Object.entries(state[data.name]).forEach((item) => {
        if (Number(item[1].id) != Number(data.id)) {
          items.push(item[1]);
        }
      });
      Vue.set(state, data.name, items);
    },
    updateOrderById(state, payload) {
      const item = state.orders.find(
        (item) => Number(item.id) === Number(payload.id)
      );
      if (!item) {
        state.orders.push(payload.order)
        return;
      }
      Object.assign(item, payload.order);
      if (state.order.id == payload.order.id) {
        Object.assign(state.order, payload.order);
      }
    },
  },
  actions: {
    find: async function ({commit, state, dispatch}, payload) {
      if (state.findOrderString == null) return;
      if (state.findOrderString == "") return;
      if (!state.findOrderString) return;
      if (
        state.findOrderString.length < 3 &&
        isNaN(parseInt(state.findOrderString))
      )
        return;
      updateField(state, {path: "isFindingOrders", value: true});
      let itemsPerPage = "";
      let sortBy = "";
      let sortDesc = "";

      if (payload.itemsPerPage) {
        itemsPerPage = "&itemsPerPage=" + payload.itemsPerPage;
      }
      if (payload.sortBy) {
        sortBy = "&sortBy=" + payload.sortBy;
      }
      if (payload.sortDesc) {
        sortDesc = "&sortDesc=" + payload.sortDesc;
      }
      return await axios
        .get(
          `${this._vm.$apiURL}/orders?find_string=${state.findOrderString}${itemsPerPage}${sortBy}${sortDesc}`
        )
        .then((response) => {
          updateField(state, {
            path: "findedOrders",
            value: response.data.data,
          });
          return true;
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "isFindingOrders", value: false});
        });
    },
    uploadImage: async function ({commit, state, dispatch}, payload) {
      updateField(state, {path: "imageLoading", value: true});
      let file = payload.file;
      if (file.type !== "image/png" && file.type !== "image/jpeg") {
        updateField(state, {path: "imageLoading", value: false});
        dispatch(
          "common/showError",
          {error: "Wrong file format"},
          {root: true}
        );
      } else {
        let formData = new FormData();
        formData.append("file", file);

        return await axios
          .post(
            this._vm.$apiURL + "/orders/order/" + payload.id + "/attach-image",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((data) => {
            updateField(state, {path: "imageLoading", value: false});
            return data;
          })
          .catch((error) => {
            updateField(state, {path: "imageLoading", value: false});
            dispatch("common/showError", {error: error}, {root: true});
          });
      }
    },
    uploadOrderItemImages: async function ({commit, state, dispatch}, payload) {
      updateField(state, {path: "imageLoading", value: true});
      let formData = new FormData();
      for (let i in payload.images) {
        formData.append('images[]', payload.images[i]);
        if (payload.images[i].type !== "image/png" && payload.images[i].type !== "image/jpeg") {
          updateField(state, {path: "imageLoading", value: false});
          dispatch(
            "common/showError",
            {error: "Wrong file format"},
            {root: true}
          );
          return;
        }
      }
      return await axios
        .post(
          this._vm.$apiURL + `/orders/${payload.order_id}/attach-item-images/${payload.item_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((data) => {
          updateField(state, {path: "imageLoading", value: false});
          if (data.data.status === 'success') {
            this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          }
          return data;
        })
        .catch((error) => {
          updateField(state, {path: "imageLoading", value: false});
          dispatch("common/showError", {error: error}, {root: true});
        });
    },
    removeOrderItemImage: async function ({commit, state, dispatch}, payload) {
      return await this._vm.$confirm( {
        title : this._vm.i18n.t('common.confirm'),
        text : this._vm.i18n.t('common.confirm_remove'),
        cancelText : this._vm.i18n.t('common.no'),
        acceptText : this._vm.i18n.t('common.yes')
      } ).then( async y  => {
        return await axios
            .delete(
                this._vm.$apiURL + `/orders/${payload.order_id}/attach-item-images/${payload.item_id}/${payload.id}`
            )
            .then((data) => {
              updateField(state, {path: "imageLoading", value: false});
              if (data.data.status === 'success') {
                this._vm.$inform(this._vm.i18n.t("common.operation_success"));
              }
              return data;
            })
            .catch((error) => {
              updateField(state, {path: "imageLoading", value: false});
              dispatch("common/showError", {error: error}, {root: true});
            });
      })
    },
    ordersUpdate({commit, state, dispatch}, payload) {
      updateField(state, {path: "savingInProgress", value: true});

      return axios
        .put(this._vm.$apiURL + "/orders/" + payload.id, payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          commit("updateOrderById", {
            id: payload.id,
            order: response.data.updated,
          });
          return response.data.updated;
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
          return false;
        })
        .finally(() => {
          updateField(state, {path: "savingInProgress", value: false});
        });
    },
    clearPayment({commit, state, dispatch}) {
      updateField(state, {
        path: "order_payment",
        value: {
          type: null,
          value: null,
        },
      });
    },
    orderCheck({commit, state, dispatch}, payload) {
      updateField(state, {path: "orderCheckLoading", value: true});
      return axios
        .post(this._vm.$apiURL + "/orders/" + payload.id + "/check")
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log('orderCheck=', error)
          //dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "orderCheckLoading", value: false});
        });
    },
    orderCheckResult({commit, state, dispatch}, payload) {
      return axios
        .post(this._vm.$apiURL + "/orders/" + payload.id + "/check-result")
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log('orderCheckResult=', error)
          //dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(() => {
          updateField(state, {path: "orderCheckLoading", value: false});
        });
    },
    async orderStore({commit, state, dispatch}, payload) {
      updateField(state, {path: "savingInProgress", value: true});
      return axios
        .post(this._vm.$apiURL + "/orders", state.newOrder, {
          params: {
            cart_id: payload && payload.cart_id,
            bid_id: payload && payload.bid_id,
          },
        })
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          updateField(state, {path: "newOrder", value: {}});
          return response.data.id;
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "savingInProgress", value: false});
        });
    },
    /**
     * Добавляем содержимое корзины к существующему заказу
     * @param commit
     * @param state
     * @param dispatch
     * @param payload
     * @returns {Promise<void>}
     */
    async orderAddFromCart({commit, state, dispatch}, payload) {
      // console.log('payload=',payload)
      // return;
      updateField(state, {path: "savingInProgress", value: true});
      return axios
        .put(this._vm.$apiURL + `/orders/${payload.order_id}/add-from-cart`, state.newOrder, {
          params: {
            cart_id: payload && payload.cart_id,
            order_id: payload && payload.order_id,
          },
        })
        .then((response) => {
          if (response.data && response.data.status === 'success') {
            this._vm.$inform(this._vm.i18n.t("common.success_add"));
            updateField(state, {path: "newOrder", value: {}});
            return response.data.id;
          }
        })
        .catch((error) => {
          dispatch("common/showError", {error: error, is_alert: true}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "savingInProgress", value: false});
        });
    },
    async fastOrderStore({commit, state, dispatch}, payload) {
      updateField(state, {path: "savingInProgress", value: true});
      return axios
        .post(this._vm.$apiURL + "/order-fast", payload)
        .then((response) => {
          if (response.data.status === "success") {
            this._vm.$inform(this._vm.i18n.t("common.success_add"));
            return response.data.human_number;
          }
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "savingInProgress", value: false});
        });
    },
    ordersCommentStore({commit, state, dispatch}) {
      updateField(state, {path: "savingInProgress", value: true});
      return axios
        .post(
          this._vm.$apiURL + "/orders/" + state.order.id + "/comment",
          state.comment
        )
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          updateField(state, {
            path: "comment",
            value: {text: null, sms: false, email: false},
          });
          dispatch("orderShow", {id: state.order.id});
          return response.data.id;
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "savingInProgress", value: false});
        });
    },
    async orderShow({commit, state, dispatch}, payload) {
      updateField(state, {path: "isFetchedOrder", value: false});
      commit("updateOrderById", {id: payload.id, order: {}});
      return await axios
        .get(this._vm.$apiURL + "/orders/" + payload.id)
        .then((response) => {
          updateField(state, {path: "order", value: response.data});
          commit("updateOrderById", {id: payload.id, order: response.data});
          return response.data;
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "isFetchedOrder", value: true});
        });
    },
    async ordersGet({commit, state, dispatch}, payload) {
      //state.order_payments_statuses
      //state.order_statuses
      updateField(state, {path: "fetched", value: false});
      return axios
        .get(this._vm.$apiURL + "/orders", {
          params: {
            find_string: state.search,
            page: state.tableOptions.page,
            itemsPerPage: state.tableOptions.itemsPerPage,
            sortBy: state.tableOptions.sortBy[0],
            sortDesc: state.tableOptions.sortDesc[0],
            systemOrderStatuses: payload.systemOrderStatuses.join(","),
            shopOrderStatuses: payload.shopOrderStatuses.join(","),
            systemOrderPaymentStatuses:
              payload.systemOrderPaymentStatuses.join(","),
            customerTypeId: payload.customerTypeId,
          },
        })
        .then((response) => {
          updateField(state, {
            path: "ordersTotal",
            value: parseInt(response.data.total),
          });
          updateField(state, {path: "orders", value: response.data.data});
          updateField(state, {
            path: "tableOptions.page",
            value: parseInt(response.data.current_page),
          });
          updateField(state, {
            path: "tableOptions.last_page",
            value: parseInt(response.data.last_page),
          });
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "fetched", value: true});
        });
    },
    ordersRemove({commit, state, dispatch}, payload) {
      this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("common.confirm_remove"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then((y) => {
          return axios
            .delete(this._vm.$apiURL + "/orders/" + payload.id, {
              id: payload.id,
            })
            .then((response) => {
              if (response.data.status === "success") {
                commit("removeFromState", {id: payload.id, name: "orders"});
                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
              }
            })
            .catch((error) => {
              dispatch("common/showError", {error: error}, {root: true});
            });
        })
        .catch((n) => {
        });
    },
    async orderPresentedGet({commit, state, dispatch}, payload) {
      updateField(state, {path: "fetched", value: false});
      updateField(state, {path: "orderPresented", value: {}});
      return await axios
        .get(this._vm.$apiURL + "/orders/" + payload.id,
          {params: {presenter: payload.presenter}}
        )
        .then((response) => {
          updateField(state, {path: "orderPresented", value: response.data});
        })
        .catch((error) => {
          dispatch("common/showError", {error: error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: "fetched", value: true});
        });
    }
  },
};
